import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { CurrencySignType, I18nService, LgType } from '../../../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-min-price',
  templateUrl: './bmcore-min-price.component.html',
  styleUrls: ['./bmcore-min-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreMinPriceComponent implements OnInit {
  @Input() minPrice: number

  lg: LgType
  currencySign: CurrencySignType

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.currencySign = this.i18nService.getCurrencySign()
    this.lg = this.i18nService.getLanguageForPage()
  }
}
